import * as React from 'react';

import {Shimmer} from "@atoms/Loaders/Shimmer";

export const ApartmentViewerPlayerLoader: React.FC = () => {
    return (
        <Shimmer style={{
            width: "100%",
            height: "100%",
            margin: 0,
        }} />
    )
};
